import { CrudBase } from "../../crud";
import { BasicCrud } from "../../../utils/interfaces/crud/imp/crud-basic";
import { QuestionnaireQuestionModel, QuestionnaireQuestionCreateModel } from "../../../models/questionnaire-question";

class _QuestionnaireQuestionController extends CrudBase {
    questionTypes = [
        {
            text: "---SELECT---",
            value: -1,
            componentName: null,
        },
        {
            text: "Yes / No",
            value: 1,
            componentName: "yes-no",
        },
        {
            text: "Select",
            value: 2,
            componentName: "multiple",
        },
        {
            text: "Rating",
            value: 3,
            componentName: "rate",
        },
    ];
    createModel = QuestionnaireQuestionCreateModel;

    constructor() {
        super({
            name: "questionnaire-question",
            modules: {
                crud: new BasicCrud()
            },
            model: QuestionnaireQuestionModel
        });
    }

    onReady() {
        this.actions = this.repo.questionnaire_question;

        this.routes = {
            edit: `/Questionnaire/Maintenance/Question/`
        }
    }

    async update(item) {
        this.loading = true;

        try {
            await this.crud.update(this.actions.update, item, '');
            // await this.getById(item.id);
            this.loading = false;
        }
        catch (err) {
            this.loading = false;
            console.log(err);
        }
    }

    onEdit() {
        return null;
    }

    getSection() {
        return this.app.get_controller("questionnaire_section").formData;
    }

    async create(section) {
        var request = new QuestionnaireQuestionCreateModel({ questionnaireSectionId: section.id });

        return await this.execute(this.actions.create, request);
    }

    async promptDelete(item) {
        this.app.$refs.confirmationDialog.showDialog({
            title: `Delete Question?`,
            message: `Are you sure you wish to delete this question?`,
            callback: "deleteItem",
            callbackData: item,
            controller: "questionnaire_question"
        });
    }

    async deleteItem(item) {
        var section = this.app.get_controller("questionnaire_section");

        await this.execute(this.actions.delete, null, `?id=${item.id}`);

        let questions = section.formData.questionnaireQuestions;

        questions.splice(questions.indexOf(item), 1);
    }

    getQuestion(questionId) {
        var section = this.getSection();
        this.formData = new this.defaultModel(section.questionnaireQuestions.find(q => q.id == questionId));
    }
}

export const QuestionnaireQuestionController = new _QuestionnaireQuestionController();